(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  const journal = document.querySelector('[data-journal-url]');
  const params = new URLSearchParams(window.location.search);
  const tag = params.get('tag');
  if (journal && tag) {
    const slug = tag.trim().toLowerCase().replace(/\s+/g, '-');
    if (slug) {
      params.delete('tag'); params.delete('page');
      const query = params.toString();
      window.location.replace(journal.dataset.journalUrl + '/tagged/' + encodeURIComponent(slug) + (query ? '?' + query : '') + window.location.hash);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-discount-form], [data-line-change], [data-remove-discounts]')) return;
    event.preventDefault();
    const root = form.closest('[data-plate-cart]');
    const error = root.querySelector('[data-cart-error]');
    const data = new FormData(form);
    if (event.submitter?.name) data.set(event.submitter.name, event.submitter.value);
    const buttons = root.querySelectorAll('button');
    const disabledBefore = Array.from(buttons, button => button.disabled);
    buttons.forEach(button => { button.disabled = true; });
    error.hidden = true;
    try {
      let url = form.action + '.js';
      let body = Object.fromEntries(data);
      const removingDiscounts = form.matches('[data-remove-discounts]');
      const newCode = String(data.get('discount') || '').trim();
      if (form.matches('[data-discount-form], [data-remove-discounts]')) {
        url = root.dataset.updateUrl;
        const codes = removingDiscounts ? [] : [...(form.dataset.existingCodes || '').split(','), newCode].map(code => code.trim()).filter(Boolean);
        body = {discount: [...new Set(codes)].join(',')};
      }
      else { body.quantity = Number(body.quantity); }
      const response = await fetch(url, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message);
      if (form.matches('[data-discount-form]')) {
        // Shopify reports each code's applicability in discount_codes (shipping discounts never appear among the
        // line or cart allocations). A code that does not apply is shown as invalid and taken back off the bag.
        const entry = (result.discount_codes || []).find(code => String(code.code).toLowerCase() === newCode.toLowerCase());
        if (!entry || !entry.applicable) {
          const kept = (form.dataset.existingCodes || '').split(',').map(code => code.trim()).filter(Boolean);
          await fetch(root.dataset.updateUrl, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({discount: kept.join(',')})});
          form.querySelector('[data-discount-error]').hidden = false;
          return;
        }
      }
      window.location.assign(root.dataset.cartUrl);
    } catch (exception) { error.hidden = false; error.focus(); }
    finally { buttons.forEach((button, index) => { button.disabled = disabledBefore[index]; }); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about-us"]) return;
  try {
    
  document.querySelectorAll('.pl-brand-film__video').forEach(video => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    video.play()?.catch(() => {});
  });

  } catch(e) { console.error(e); }
})();
})();
